import { Pipe, PipeTransform, inject } from '@angular/core';
import { DurationUnit } from '@lx/shared/data-access/types';
import { DurationUnitsService } from '@lx/shared/utils/services';

/**
 * Pipe to localize and pluralize duration periods
 *
 * @example
 * // Long format (default):
 * {{ 1 | klgLocalizeAndPluralizePeriod: 'HOURS' }}  // "1 hour"
 * {{ 5 | klgLocalizeAndPluralizePeriod: 'HOURS' }}  // "5 hours"
 *
 * // Short format:
 * {{ 1 | klgLocalizeAndPluralizePeriod: 'HOURS' : true }}  // "1 h"
 * {{ 5 | klgLocalizeAndPluralizePeriod: 'DAYS' : true }}   // "5 d"
 */
@Pipe({
  name: 'lxLocalizeAndPluralizePeriod',
  standalone: true,
})
export class LocalizeAndPluralizePeriodPipe implements PipeTransform {
  private readonly durationUnitsService = inject(DurationUnitsService);

  /**
   * Transforms a quantity and duration unit into a localized, pluralized string
   * @param quantity - The quantity of the duration unit
   * @param durationUnit - The duration unit (optional, defaults to 'WEEKS')
   * @param short - Whether to use short format (optional, defaults to false)
   * @returns Formatted duration text
   */
  transform(quantity: number, durationUnit?: DurationUnit, short = false): string {
    if (short) {
      return this.durationUnitsService.getShortDurationText(quantity, durationUnit);
    }
    return this.durationUnitsService.getDurationText(quantity, durationUnit);
  }
}
